export default {
  "1": "一级群".toUpperCase(),
  "2": "二级群".toUpperCase(),
  "3": "三级群".toUpperCase(),
  low: "低质内容".toUpperCase(),
}
